import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";

/**
 * Simple popup modal for when an error occurs.
 * @callback OnHideParent
 * 
 * @param {string} errorMessage Error Message to display in the modal 
 * @param {OnHideParent} onHideParent Callback to close parent modal (if given)
 * @returns {React.JSX.Element}
 */
export default function ErrorModal({ errorMessage, onHideParent=f => f }) {
  const [show, setShow] = useState(true);

  const handleHide = () => {
    setShow(false);
    onHideParent();
  };

  return (
    <Modal show={show} onHide={handleHide} style={{ zIndex: 9999 }}>
      <Modal.Header closeButton>
        <Modal.Title>Error</Modal.Title>
      </Modal.Header>
      <Modal.Body>{errorMessage}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}